import { type SourcingRun } from "@vidario/domain";
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Starts the backend sourcing pipeline for a job — the "An Vidario
 * senden" action. Seeds the run cache so the Longlist shows progress
 * immediately, without waiting for the first poll. */
export function useStartSourcing(): UseMutationResult<SourcingRun, Error, string> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId) => client.startSourcing(jobId),
    onSuccess: (run, jobId) => {
      qc.setQueryData(queryKeys.sourcingRun(jobId), run);
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
